import { FloraTypography } from '@grupoboticario/flora-react';

import { TEXT_BLOCK_CONST, TextBlockConfig } from './TextBlock.d';
import { TextBlockStyle } from './TextBlock.style';

const TextBlock = ({ icon, iconColor, text, textAlign, variant }: TextBlockConfig) => (
  <TextBlockStyle.Component data-testid={TEXT_BLOCK_CONST.TEST_ID}>
    {icon && (
      <TextBlockStyle.IconWrapper data-icon-color={iconColor}>{icon}</TextBlockStyle.IconWrapper>
    )}

    <TextBlockStyle.Info>
      <FloraTypography fontSize={variant}>{text}</FloraTypography>
    </TextBlockStyle.Info>
  </TextBlockStyle.Component>
);

export default TextBlock;
